import { Field, StepData } from "../FormViewer/FormViewer.types";
import { getNextStepIndex, handleDuplicateStep, handleStatus } from "./handlers";

import { IAppContext } from "../../util/context";
import { handleApiRequest } from "./handleApiRequest";
import { handleStepTransition } from "./handleStepTransition";
import { trackEvent } from "../../util/functions";

export const handleStepSubmit = async (context: IAppContext, stepData: StepData ) => {
  const { steps, activeStepIndex, settings: { disablePartialLeads, emailRecipient, apiEndpoint, defaultSuccessPageUrl, successPageRules }, updateDisableButton, disableButton } = context;
  const { fields, answer,  settings: { tracking, last_step } } = stepData;
  const { next_step_answer } = answer || {};
  const nextStepIndex =  getNextStepIndex(activeStepIndex, stepData, steps, context);
  handleDuplicateStep(stepData)

  const hasSuccessStep = steps[nextStepIndex]?.isSuccessPage || false;
  const is_last_step = (last_step && !next_step_answer) || activeStepIndex === steps.length - 1;

  stepData.is_last_step = is_last_step;

  tracking && trackEvent(tracking.gtmEvent);

  const requestConditions = {
    is_last_step,
    disablePartialLeads,
    emailRecipient,
    hasSuccessStep,
    defaultSuccessPageUrl,
    successPageRules,
    stepHasEmailField: !!fields?.find((field: Field) => field.field_crm_id === "email"),
    stepHasPhoneField: !!fields?.find((field: Field) => field.field_crm_id === "phone")
  }

  updateDisableButton(!disableButton);
  const response = await handleApiRequest(apiEndpoint, requestConditions);
  const success = handleStatus(response, context);

  if (!success) return;

  !is_last_step && handleStepTransition(context, stepData);

  if(steps.length === 1) {
    trackEvent("formClient.started");
  }
}
